import * as React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Profil from '../components/Contacts/Profil';



export default function PrivateProfilPage() {
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('md'));

    React.useEffect( () => {    
        // if(!isSmall){
        //     setDrawerOpen(true)
        // }else{
        //     setDrawerOpen(false)
        // }
    }, [isSmall ] );

// React.useEffect( () => {
//     var myDiv = document.getElementById('containerDiv');
//     // myDiv.innerHTML = variableLongText;
//     myDiv.scrollTop = 0;
// }, []);
    const user = {nick_name: 'Przemysław Moszko'}

  return (
    <div style={{ position: 'relative', width: '100%', height: 'calc(100dvh - 65px)', display: 'flex', flexDirection: 'row' }}>
        <Profil owner={true} user={user} />
    </div>
  );
}
